<template>
  <div class="main">
    <div class="curse-content">
      <div class="curse-tex">当前位置：申报列表</div>
    </div>
    <div class="list-content">
      <div class="search-box">
        <div class="search-item">
          <el-input v-model="search.keyword" placeholder="关键词"></el-input>
        </div>
        <div class="search-item">
          <el-select
            v-model="search.organ_id"
            placeholder="机构名称"
            style="width: 100%"
            :clearable="true"
          >
            <el-option
              v-for="item in orgOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="search-item">
          <el-select
            v-model="search.status"
            placeholder="审核状态"
            style="width: 100%"
            :clearable="true"
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="search-item">
          <el-date-picker
            v-model="search.time"
            value-format="yyyy-MM-dd"
            end-placeholder="结束日期"
            range-separator="至"
            start-placeholder="开始日期"
            type="daterange"
            style="width: 100%"
          >
          </el-date-picker>
        </div>
        <div class="search-item">
          <el-select
            v-model="search.project_class"
            placeholder="项目类别"
            @change="child()"
            :clearable="true"
            style="width: 50%"
          >
            <el-option
              v-for="item in directionOne"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="search.project_direction"
            placeholder="项目方向"
            :clearable="true"
            style="width: 50%"
          >
            <el-option
              v-for="item in directionTwo"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="search-item">
          <el-select
            v-model="search.organ_class"
            placeholder="申报单位属性"
            :clearable="true"
            style="width: 100%"
          >
            <el-option
              v-for="item in orgclass"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="search-item">
          <el-select
            v-model="search.province_id"
            placeholder="省"
            :clearable="true"
            @change="cityList()"
            style="width: 50%"
          >
            <el-option
              v-for="item in provinceclass"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="search.city_id"
            placeholder="市"
            :clearable="true"
            style="width: 50%"
          >
            <el-option
              v-for="item in cityclass"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="search-item" style="flex: 1">
          <el-button type="primary" icon="el-icon-refresh" @click="searchreset">
            重置
          </el-button>
          <el-button type="primary" icon="el-icon-search" @click="searchFun">
            搜索
          </el-button>
          <el-button
            type="primary"
            @click="exportReportList(2)"
            v-if="user.id === 7"
          >
            下载结项评审补充资料
          </el-button>
        </div>
      </div>

      <!-- status  审核状态 1 待审核 2 审核通过 3 审核驳回     -->
      <div class="list-box" v-if="list.length > 0">
        <div class="item" v-for="item in list" :key="item.id">
          <div class="item-title ovHide">
            {{ item.project_name }}
          </div>
          <div class="item-time">{{ zhDate(item.create_time * 1000) }}</div>
          <div class="item-set">
            <div class="flex justify-start align-center">
              <!-- <div class="item-type green" v-if="item.status == 2">
                已完成绩效指标
              </div> -->

              <!-- <div class="item-type blue" v-if="item.status == 1">正在执行</div> -->

              <!-- <el-tag type="danger" style="margin-right: 10px">
                {{ item.organ_name }}
              </el-tag> -->

              <el-tag
                type="info"
                v-if="
                  item.supply_project_contract.length === 0 &&
                  item.supply_report_file.length === 0 &&
                  item.supply_finance_file.length === 0 &&
                  item.supply_record_file.length === 0 &&
                  item.supply_financial_data.length === 0
                "
              >
                未上传
              </el-tag>

              <el-tag type="success" v-else> 已提交结项评审补充资料 </el-tag>

              <!-- <a
                :href="item.project_contract[0].href"
                v-if="item.project_contract.length > 0"
                class="item-look"
                style="width: auto; padding: 0 10px"
                target="_blank"
                download
              >
                项目实施方案（合同签订版）
              </a>

              <a
                :href="item.report_file[0].href"
                v-if="item.report_file.length > 0"
                class="item-look"
                style="width: auto; padding: 0 10px"
                target="_blank"
                download
              >
                《项目中期/结项自评报告》WORD版及盖章PDF版
              </a>

              <a
                :href="item.ppt_file[0].href"
                v-if="item.ppt_file.length > 0"
                class="item-look"
                style="width: auto; padding: 0 10px"
                target="_blank"
                download
              >
                汇报PPT（可编辑版及PDF版）
              </a>

              <a
                :href="item.finance_file[0].href"
                v-if="item.finance_file.length > 0"
                class="item-look"
                style="width: auto; padding: 0 10px"
                target="_blank"
                download
              >
                财务预决算对照表
              </a>

              <a
                :href="item.record_file[0].href"
                v-if="item.record_file.length > 0"
                class="item-look"
                style="width: auto; padding: 0 10px"
                target="_blank"
                download
              >
                项目过程档案资料
              </a>

              <a
                :href="item.financial_data[0].href"
                v-if="item.financial_data.length > 0"
                class="item-look"
                style="width: auto; padding: 0 10px"
                target="_blank"
                download
              >
                财务资料
              </a> -->
            </div>

            <div class="item-btnbox">
              <router-link
                class="item-btn"
                :to="`/adminhome/supply_project_list/detail?id=${
                  item.id
                }&keyword=${search.keyword}&organ_id=${
                  search.organ_id
                }&status=${search.status}&time=${JSON.stringify(
                  search.time,
                )}&project_class=${search.project_class}&project_direction=${
                  search.project_direction
                }&organ_class=${search.organ_class}&province_id=${
                  search.province_id
                }&city_id=${search.city_id}&page=${search.page}`"
              >
                <i class="iconfont icon-redact"></i>
                查看详情
              </router-link>
            </div>
          </div>
          <div class="item-feedback" v-if="item.status == 3">
            驳回原因：<span>{{ item.refund_reason }}</span>
          </div>
        </div>

        <div class="page-box flex justify-center padding-top-sm">
          <el-pagination
            class="page-all margin-bottom"
            background
            @current-change="init"
            :current-page.sync="search.page"
            :page-size="search.limit"
            layout="prev, pager, next"
            :total="search.total"
          >
          </el-pagination>
        </div>
      </div>

      <el-empty :image-size="200" v-if="list.length == 0"></el-empty>
    </div>
  </div>
</template>
<script>
import {
  exitProjectApprove,
  exportProjectList,
  exportProjectExcel,
  getOrganPassList,
  getProjectFileList,
  exportEndProjectFileList,
} from "@/api/admin";
import { zhDate } from "@/tools";
import { baseURL } from "@/config";
import {
  cityList,
  getOrganClassList,
  getProjectClassLevelList,
  getProjectClassList,
} from "@/api";
import { downloadFile } from "@/utils/utils";

/**
 * @author yan st
 * @date 2022-08-16 08:40
 * @Description:
 */
import { getfile, qspost } from "@/plugins/axios";

export default {
  name: "index",
  data() {
    return {
      zhDate: zhDate,
      baseURL: baseURL,
      orgOptions: [],
      directionOne: [],
      directionTwo: [],
      provinceclass: [],
      cityclass: [],
      orgclass: [],
      statusOptions: [
        {
          value: 1,
          label: "正在执行",
        },
        {
          value: 2,
          label: "已完成绩效指标",
        },
      ],
      list: [],
      search: {
        keyword: "",
        organ_id: "",
        status: "",
        time: [],
        project_class: "",
        project_direction: "",
        organ_class: "",
        province_id: "",
        city_id: "",
        page: 1,
        limit: 10,
        total: 0,
      },
    };
  },
  computed: {
    token() {
      return this.$store.state.admintoken;
    },
    user() {
      return this.$store.state.adminuser;
    },
  },
  components: {},
  created() {
    this.$emit("setActive", {
      active: 10,
    });

    if (this.$route.query.page) {
      this.search.keyword = this.$route.query.keyword;
      this.search.organ_id = this.$route.query.organ_id
        ? Number(this.$route.query.organ_id)
        : "";
      this.search.status = this.$route.query.status
        ? Number(this.$route.query.status)
        : "";
      this.search.time = this.$route.query.time
        ? JSON.parse(this.$route.query.time)
        : [];
      this.search.project_class = this.$route.query.project_class
        ? Number(this.$route.query.project_class)
        : "";
      this.search.project_direction = this.$route.query.project_direction
        ? Number(this.$route.query.project_direction)
        : "";
      this.search.organ_class = this.$route.query.organ_class
        ? Number(this.$route.query.organ_class)
        : "";
      this.search.province_id = this.$route.query.province_id
        ? Number(this.$route.query.province_id)
        : "";
      this.search.city_id = this.$route.query.city_id
        ? Number(this.$route.query.city_id)
        : "";

      this.search.page = Number(this.$route.query.page);

      this.child();

      this.cityList();
    }
    this.searchInit();
    this.init();
  },
  methods: {
    // 获取列表
    async init() {
      let _data = await getProjectFileList(
        this.search.keyword,
        this.search.organ_id,
        this.search.status,
        this.search.time ? this.search.time[0] : "",
        this.search.time ? this.search.time[1] : "",
        this.search.project_class,
        this.search.project_direction,
        this.search.organ_class,
        this.search.province_id,
        this.search.city_id,
        this.search.page,
        this.search.limit,
      );
      if (_data.code === 200) {
        this.list = _data.data.data;
        this.search.total = _data.data.total;
      } else {
        this.$message.error(_data.message);
      }
    },

    async exportReportList(type = 1) {
      let loading = this.$loading({
        lock: true,
        text: "正在打包下载，请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      let _data = await exportEndProjectFileList(
        this.search.keyword,
        this.search.organ_id,
        this.search.status,
        this.search.time ? this.search.time[0] : "",
        this.search.time ? this.search.time[1] : "",
        this.search.project_class,
        this.search.project_direction,
        this.search.organ_class,
        this.search.province_id,
        this.search.city_id,
        2,
      );

      console.log("_data", _data);

      setTimeout(async () => {
        loading.close();

        let data = await getfile(_data.data);

        console.log(data);

        downloadFile(data.data, "结项评审补充资料.zip");
      }, 3000);
    },

    async exportFile(name = "", type = 1) {
      if (name === "") {
        let _data = await exportProjectList(
          this.search.keyword,
          this.search.organ_id,
          this.search.status,
          this.search.time ? this.search.time[0] : "",
          this.search.time ? this.search.time[1] : "",
          this.search.project_class,
          this.search.project_direction,
          this.search.organ_class,
          this.search.province_id,
          this.search.city_id,
          type,
        );
        downloadFile(_data.data, "项目列表.xlsx");
      } else {
        let _data = await exportProjectExcel(
          this.search.keyword,
          this.search.organ_id,
          this.search.status,
          this.search.time ? this.search.time[0] : "",
          this.search.time ? this.search.time[1] : "",
          this.search.project_class,
          this.search.project_direction,
          this.search.organ_class,
          this.search.province_id,
          this.search.city_id,
        );
        downloadFile(_data.data, name + "-项目列表.xlsx");
      }
    },
    searchFun() {
      this.search.page = 1;
      this.init();
    },
    searchreset() {
      this.search = {
        keyword: "",
        organ_id: "",
        status: "",
        time: [],
        project_class: "",
        project_direction: "",
        organ_class: "",
        province_id: "",
        city_id: "",
      };
      this.$router.push(`/adminhome/declarelist`);
      this.search.page = 1;
      this.init();
    },

    async searchInit() {
      // 申报单位属性列表
      let res = await getOrganClassList();
      if (res.code == 200) {
        this.orgclass = res.data;
        this.orgclass.map((item) => {
          item.label = item.name;
        });
      }
      // 项目方向列表
      let _data = await getProjectClassList();
      this.directionOne = _data.data;
      this.directionOne.map((item) => {
        item.label = item.class_name;
        item.value = item.id;
      });
      // 城市列表
      let _info = await cityList();
      this.provinceclass = _info.data;
      this.provinceclass.map((item) => {
        item.label = item.name;
        item.value = item.id;
      });
      // 机构列表
      let _org = await getOrganPassList();
      this.orgOptions = _org.data;
      this.orgOptions.map((item) => {
        item.label = item.organ_name;
        item.value = item.id;
      });
    },

    // 项目方向层级列表
    async child() {
      let _data = await getProjectClassLevelList(this.search.project_class);
      this.directionTwo = _data.data;
      this.directionTwo.map((item) => {
        item.label = item.class_name;
        item.value = item.id;
      });
    },

    //城市列表
    async cityList() {
      let _data = await cityList(this.search.province_id);
      this.cityclass = _data.data;
      this.cityclass.map((item) => {
        item.label = item.name;
        item.value = item.id;
      });
    },

    to(path) {
      this.$router.push(path);
    },
  },
  watch: {},
  filters: {},
};
</script>

<style scoped lang="scss">
.main {
  width: 100%;

  .curse-content {
    width: 100%;
    padding: 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-right: 15px;

    .curse-tex {
      font-size: 16px;
      color: #333333;
    }

    .curse-btn {
      width: 108px;
      height: 36px;
      background-color: #5298e2;
      border-radius: 10px 10px 0px 0px;
      text-align: center;
      line-height: 36px;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
    }
  }

  .list-content {
    width: 100%;
    min-height: 500px;
    border: 1px solid #999999;
    background: #ffffff;
    border-radius: 20px;
    padding: 20px;

    .list-box {
      border-top: 1px solid #eceef0;
    }

    .search-box {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      .search-item {
        width: 33.3%;
        padding-right: 20px;
        margin-bottom: 20px;
      }
    }

    .item {
      width: 100%;
      padding: 20px 0;
      border-bottom: 1px solid #eceef0;

      .item-feedback {
        width: 100%;
        padding: 10px 15px;
        background-color: #f7f7f7;
        font-size: 14px;
        font-weight: bold;
        color: #ed3434;
        margin-top: 10px;

        span {
          color: #333333;
          font-weight: normal;
        }
      }

      .item-set {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .item-btnbox {
          flex: 1;
          margin-left: 50px;
          display: flex;
          justify-content: flex-end;
          align-items: center;

          .item-btn {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            cursor: pointer;
            font-size: 14px;
            color: #333333;
            margin-left: 20px;

            i {
              font-size: 16px;
              color: #333333;
              margin-right: 4px;
            }
          }
        }

        .item-look {
          width: 100px;
          height: 28px;
          border-radius: 6px;
          text-align: center;
          line-height: 28px;
          font-size: 14px;
          background-image: linear-gradient(90deg, #0115a6 0%, #1546c5 100%);
          margin-left: 15px;
          cursor: pointer;
          color: #ffffff;
        }

        .item-type {
          //width: 72px;
          padding: 0 10px;
          height: 28px;
          border-radius: 6px;
          text-align: center;
          line-height: 28px;
          font-size: 14px;

          &.grey {
            color: #999999;
            background-color: #f3f3f3;
          }

          &.red {
            color: #eb1d1d;
            background-color: #ffeded;
          }

          &.green {
            color: #1ea735;
            background-color: #e9f8e5;
          }

          &.blue {
            color: #3381c3;
            background-color: #e5eff8;
          }
        }
      }

      .item-time {
        width: 100%;
        font-size: 14px;
        color: #999999;
        margin: 10px 0;
      }

      .item-title {
        width: 100%;
        font-size: 16px;
        color: #333333;
      }
    }
  }
}
</style>
